import StaffContent from "./StaffContent"; 
const Staff = ()=>{
  return (
    <>
    <div className = "flex flex-col justify-center items-center gap-4">
      <h1 className = "text-xl font-bold text-center"> Our Expert Team Members</h1>
      <p className = "p-4 md:p-8">Behind every great product is an exceptional team. Meet our group of skilled professionals, each bringing years of experience, creativity, and expertise to the table. Together, we are committed to delivering top-notch solutions, exceeding client expectations, and driving innovation every step of the way 
    </p>
    <div className = "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 justify-center items-center">
      <StaffContent imgUrl = {"https://i.ibb.co/Pt8zPVy/pexels-linkedin-2182970.jpg"} name = {"Daniel k"} rank = {"CEO"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/FWf2nTF/darshan-patel-QJEVpydul-Gs-unsplash.jpg"} name = {"Robbert Moris"} rank = {"CTO"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/HKVJVDz/clay-elliot-mp-DV4xa-FP8c-unsplash.jpg"} name = {"Emily walker"} rank = {"CFO"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/LSRjhzd/albert-dera-ILip77-Sbm-OE-unsplash-1.jpg"} name = {"Albert James"} rank = {"COO"}/>
<StaffContent imgUrl = {"https://i.ibb.co/gJ5gQW8/alexander-hipp-i-EEBWg-Y-6l-A-unsplash.jpg"} name = {"James Cater"} rank = {"CIO"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/LpF0H9L/pexels-koraybozkurt-15143986.jpg"} name = {"John Robbert"} rank = {"Portfolio Manager"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/3CLGWZh/pexels-olly-3778602.jpg"} name = {"William Davis"} rank = {"Risk Manager"}/>
    <StaffContent imgUrl = {"https://i.ibb.co/c8yNycX/michael-dam-m-EZ3-Po-FGs-k-unsplash.jpg"} name = {"Sofia Willson"} rank = {"Compliance Officer"}/>
    </div>
    </div>
    </>
  ); 
}
export default Staff; 

